import * as angular from 'angular';
import CategoriesBridge from './bridges/CategoriesBridge';
angular
  .module('flowingly.runner.setup')
  .component('subCategories', CategoriesBridge);
